import { Survey } from '../model/survey';
export class SurveyBuilder {
    static buildSurvey(data) {
        let survey = new Survey();
        survey.id = data.id;
        survey.name = data.name;
        survey.id_surveys_group = data.id_surveys_group;
        survey.id_product = data.id_product;
        survey.product_type = data.product_type;
        survey.product_extra_type = data.product_extra_type;
        survey.id_product_extra = data.id_product_extra;
        survey.type = data.type;
        survey.sort = data.sort;
        survey.active = data.active === '1' ? true : false;
        survey.text_es = data.text_es;
        survey.text_en = data.text_en;
        survey.text_ca = data.text_ca;
        survey.text_fr = data.text_fr;
        survey.date_created = data.date_created || null;
        survey.options = data.options;
        survey.main_question = data.main_question === '1' ? true : false;
        return survey;
    }
}
//# sourceMappingURL=survey-builder.js.map